import React from "react";
import { useTranslation } from "react-i18next";
import * as moment from 'moment';

const Card = ({ data }) => {
    const { t } = useTranslation();

    const formatAmount = (value) => {
        const numericValue = Number(value || 0);
        return Number.isFinite(numericValue) ? numericValue.toLocaleString() : value;
    };

    const rows = [
        { label: t("openingBalance"), value: data?.opening },
        { label: t("inward"), value: data?.inward, valueClass: "text-emerald-600 dark:text-emerald-300" },
        { label: t("betAmount"), value: data?.bet, valueClass: "text-rose-600 dark:text-rose-300" },
        { label: t("profitAmount"), value: data?.win, valueClass: "text-emerald-600 dark:text-emerald-300" },
        { label: t("outward"), value: data?.outward, valueClass: "text-rose-600 dark:text-rose-300" },
    ];

    return (
        <article className="overflow-hidden rounded-lg border border-slate-200 bg-white font-inter text-sm text-slate-700 shadow-sm dark:border-white/[0.14] dark:bg-white/[0.08] dark:text-white">
            <div className="flex items-center justify-between border-b border-slate-100 bg-slate-50 px-4 py-3 dark:border-white/[0.1] dark:bg-white/[0.06]">
                <p className="font-dangrek text-primary dark:text-white">{t("statement")}</p>
                <p className="rounded-md bg-white px-2 py-1 text-xs text-content shadow-sm dark:bg-white/[0.1] dark:text-white/[0.75]">
                    {
                        moment(new Date(data?.date)).format('DD.MM.YYYY h:mm A')
                    }
                </p>
            </div>
            <div className="divide-y divide-slate-100 px-4 dark:divide-white/[0.08]">
                {rows.map((row) => (
                    <div key={row.label} className="grid grid-cols-[1fr_auto] items-center gap-4 py-3">
                        <h4 className="text-slate-500 dark:text-white/[0.65]">{row.label}</h4>
                        <p className={`font-myanmarSansPro font-semibold ${row.valueClass || "text-slate-800 dark:text-white"}`}>
                            {formatAmount(row.value)}
                        </p>
                    </div>
                ))}
            </div>
            <div className="grid grid-cols-[1fr_auto] items-center gap-4 bg-primary/[0.08] px-4 py-3 dark:bg-white/[0.08]">
                <h4 className="text-primary dark:text-white">{t("closingBalance")}</h4>
                <p className="font-myanmarSansPro text-base font-bold text-primary dark:text-white">
                    {formatAmount(data?.closing)}
                </p>
            </div>
        </article>
    );
}

export default Card;
